module.exports = __webpack_public_path__ + "static/img/logo2.7998f75.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo2.png
// module id = YpdP
// module chunks = 1